import { ms } from "humanize-ms";
import { delay, put } from "typed-redux-saga";
import { setAppReady } from "../slices/applicationSlice";

function* initializeApp() {
    yield* delay(ms("3s"));
    yield* put(setAppReady(true));
}

export function* applicationSaga() {
    yield* initializeApp();
}
